import { AnyUser } from "@megaron/access-control";
import { HttpService } from "@megaron/http-service";
import { HandlerMap } from "@megaron/http-service-host";

import { exportItemsActions } from "./exportItems";
import { importItemsActions } from "./importItems";
import { itemsActions } from "./items";

export const catalogHttpService = HttpService({
  ...itemsActions,
  ...importItemsActions,
  ...exportItemsActions,
});

export type CatalogHandlers = HandlerMap<typeof catalogHttpService, AnyUser>;
